import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerinCourtOwner from "../../components/DatePickerinCourtOwner";
// import "./adminstyle.css";
const API = "https://api.getfitindia.in/api/admin/reports";

export default function AdminReports() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [owners, setOwners] = useState([]);
  const [venues, setVenues] = useState([]);

  const [selectedOwner, setSelectedOwner] = useState("all");
  const [selectedVenue, setSelectedVenue] = useState("all");

  const [summary, setSummary] = useState(null);
  const [list, setList] = useState([]);

  const [range, setRange] = useState("all");

  const [startDate, setStartDate] = useState(() => new Date());
  const [endDate, setEndDate] = useState(() => new Date());
  const [showFilter, setShowFilter] = useState(false);

  // 🔹 For GET REPORT dropdown
  const [showDropdown, setShowDropdown] = useState(false);

  /* ---------------- FETCH OWNERS ---------------- */
  const fetchOwners = async () => {
    try {
      const res = await fetch(`${API}/owners`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setOwners(data);
    } catch (err) {
      console.error("owner fetch err:", err);
    }
  };

  /* ---------------- FETCH VENUES ---------------- */
  const fetchVenues = async () => {
    try {
      const res = await fetch(`${API}/venues`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setVenues(data);
    } catch (err) {
      console.error("venue fetch err:", err);
    }
  };

  /* ---------------- FETCH SUMMARY ---------------- */
  const fetchSummary = async () => {
    try {
      let url = `${API}/summary?from=${startDate.toISOString()}&to=${endDate.toISOString()}`;

      if (selectedOwner !== "all") url += `&ownerId=${selectedOwner}`;
      if (selectedVenue !== "all") url += `&venueId=${selectedVenue}`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSummary(data);
    } catch (err) {
      console.error("summary err:", err);
    }
  };

  /* ---------------- FETCH LIST ---------------- */
  const fetchList = async () => {
    try {
      let url = `${API}/list?from=${startDate.toISOString()}&to=${endDate.toISOString()}`;

      if (selectedOwner !== "all") url += `&ownerId=${selectedOwner}`;
      if (selectedVenue !== "all") url += `&venueId=${selectedVenue}`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      setList(data.items || []);
    } catch (err) {
      console.error("list err:", err);
    }
  };

  /* ---------------- LOAD INITIAL ---------------- */
  useEffect(() => {
    if (token) {
      fetchOwners();
      fetchVenues();
      fetchSummary();
      fetchList();
    }
  }, [token]);

  /* ---------------- UPDATE WHEN FILTERS CHANGE ---------------- */
  useEffect(() => {
    if (!token) return;
    fetchSummary();
    fetchList();
  }, [selectedOwner, selectedVenue, startDate, endDate]);

  /* ---------------- PRESET RANGES ---------------- */
  const setRangePreset = (key) => {
    const today = new Date();
    setRange(key);

    if (key === "today") {
      setStartDate(today);
      setEndDate(today);
    }
    if (key === "yesterday") {
      const y = new Date(today);
      y.setDate(today.getDate() - 1);
      setStartDate(y);
      setEndDate(y);
    }
    if (key === "last7") {
      const d = new Date(today);
      d.setDate(today.getDate() - 6);
      setStartDate(d);
      setEndDate(today);
    }
    if (key === "last30") {
      const d = new Date(today);
      d.setDate(today.getDate() - 29);
      setStartDate(d);
      setEndDate(today);
    }
    if (key === "mtd") {
      const d = new Date(today.getFullYear(), today.getMonth(), 1);
      setStartDate(d);
      setEndDate(today);
    }
    if (key === "all") {
      setStartDate(new Date("2025-01-01"));
      setEndDate(today);
    }
  };

  /* ---------------- EXPORT EXCEL (GET REPORT) ---------------- */
  const handleExportExcel = async () => {
    try {
      setShowDropdown(false);

      // use from + to so backend's parseRange uses direct dates
      let endpoint = `${API}/export/excel?from=${startDate.toISOString()}&to=${endDate.toISOString()}`;

      if (selectedOwner !== "all") endpoint += `&ownerId=${selectedOwner}`;
      if (selectedVenue !== "all") endpoint += `&venueId=${selectedVenue}`;

      const res = await fetch(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Download failed");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Admin_Report.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Excel export error:", err);
      alert("❌ Failed to download Excel report");
    }
  };

  return (
    <div className="">
      <div className="flex-1 ">
        {/* HEADER */}
        <div className="bg-[#0f2250] text-white sticky top-0 z-20">
          <div className="max-w-6xl  px-4 py-4">
            <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
              Admin Reports
            </h1>
          </div>
        </div>

        {/* FILTERS */}
        <div className="w-full flex flex-wrap items-center gap-1 sm:gap-3 mb-4 p-3 md:p-6">
          {/* Owner Dropdown */}
          <select
            className="border border-gray-400 rounded-full px-4 py-2 text-sm bg-white focus:outline-none min-w-[130px]"
            value={selectedOwner}
            onChange={(e) => setSelectedOwner(e.target.value)}
          >
            <option value="all">All</option>
            {owners.map((o) => (
              <option key={o._id} value={o._id}>
                {o.name}
              </option>
            ))}
          </select>

          {/* Venue Dropdown */}
          <select
            className="border border-gray-400 rounded-full px-4 py-2 text-sm bg-white focus:outline-none min-w-[130px]"
            value={selectedVenue}
            onChange={(e) => setSelectedVenue(e.target.value)}
          >
            <option value="all">All Venues</option>
            {venues.map((v) => (
              <option key={v._id} value={v._id}>
                {v.name}
              </option>
            ))}
          </select>

          {/* Filter Button */}
          <button
            onClick={() => setShowFilter(true)}
            className="border border-gray-400 rounded-full px-4 py-2 text-sm bg-white shadow-sm hover:bg-gray-100 min-w-[100px]"
          >
            ⚙️ Filter
          </button>

          {/* Range Dropdown */}
          <select
            className="border border-gray-400 rounded-full px-4 py-2 text-sm bg-white focus:outline-none min-w-[130px]"
            onChange={(e) => setRangePreset(e.target.value)}
          >
            <option value="all">All</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="last7">Last 7 Days</option>
            <option value="last30">Last 30 Days</option>
            <option value="mtd">This Month</option>
          </select>
        </div>

        {/* Date display */}
        <div className="text-center">
          {startDate && endDate && (
            <p className="text-gray-600 text-sm font-medium ml-1">
              {startDate.toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}{" "}
              —{" "}
              {endDate.toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </p>
          )}
        </div>

        {/* SUMMARY CARDS WITH PERFECT SCROLL */}
        {summary && (
          <div className="relative w-full mb-4 group overflow-hidden ps-3 pe-3 pb-1 pt-1 ">
            {/* Scrollable Strip */}
            <div
              id="adminSummaryScroll"
              className="
                flex overflow-x-auto no-scrollbar space-x-3 
                pb-3 px-1 pt-1 
                snap-x snap-mandatory 
                scroll-smooth
                w-full
              "
              style={{
                WebkitOverflowScrolling: "touch",
              }}
            >
              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Revenue" value={`₹ ${summary.totalRevenue}`} />
              </div>

              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Online" value={`₹ ${summary.onlineRevenue}`} />
              </div>

              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Offline" value={`₹ ${summary.offlineRevenue}`} />
              </div>

              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Bookings" value={summary.totalBookings} />
              </div>

              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Slots" value={summary.totalSlots} />
              </div>

              <div className="min-w-[150px] snap-start flex-shrink-0">
                <SummaryCard title="Cancelled" value={summary.cancellations} color="red" />
              </div>
            </div>

            {/* LEFT ARROW */}
            <button
              onClick={() =>
                document
                  .getElementById("adminSummaryScroll")
                  .scrollBy({ left: -200, behavior: "smooth" })
              }
              className="
                hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 
                bg-white shadow-md border border-gray-300 
                w-8 h-8 rounded-full items-center justify-center
                hover:bg-gray-100 opacity-0 group-hover:opacity-100
                transition
              "
            >
              ‹
            </button>

            {/* RIGHT ARROW */}
            <button
              onClick={() =>
                document
                  .getElementById("adminSummaryScroll")
                  .scrollBy({ left: 200, behavior: "smooth" })
              }
              className="
                hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 
                bg-white shadow-md border border-gray-300 
                w-8 h-8 rounded-full items-center justify-center
                hover:bg-gray-100 opacity-0 group-hover:opacity-100
                transition
              "
            >
              ›
            </button>
          </div>
        )}

        {/* BOOKING LIST */}
        <div className="p-3 md:p-6">
          <h3 className="text-md font-semibold text-[#0f2250] mb-5">Bookings</h3>

          {list.length === 0 && <p>No bookings found.</p>}

          <div className="flex flex-col gap-4">
            {list.map((b) => {
              const status = b.status?.toUpperCase() || "";
              const isOnline = b.razorpay_payment_id ? true : false;

              return (
                <div
                  key={b._id}
                  className="rounded-xl p-4 border shadow-sm bg-[#fffbfb]  hover:bg-[#eaeaea] cursor-pointer transition  border-gray-200"
                  onClick={() => navigate(`/courtowner/booking/${b._id}`)}
                >
                  {/* TOP ROW */}
                  <div className="flex justify-start items-start">
                    {/* STATUS */}
                    <span
                      style={{ fontSize: "0.6rem" }}
                      className={` font-semibold me-1 px-2 py-0.5 rounded-2xl  ${
                        status === "PAID" || status === "CONFIRMED"
                          ? "bg-green-600 text-white border border-green-600"
                          : status === "CANCELLED"
                          ? "bg-orange-700 text-white border border-orange-700"
                          : "bg-gray-500 text-white border border-gray-500"
                      }`}
                    >
                      {status === "PAID" ? "CONFIRMED" : status}
                    </span>

                    {/* ONLINE / OFFLINE */}
                    <span
                      style={{ fontSize: "0.6rem" }}
                      className={` font-semibold  px-2 py-0.5 rounded-2xl ${
                        isOnline
                          ? "bg-white text-black border border-black"
                          : "bg-yellow-500 text-white"
                      }`}
                    >
                      {isOnline ? "ONLINE" : "OFFLINE"}
                    </span>

                    {/* BOOKING ID */}
                    <span className=" ms-3  text-xs text-gray-500 font-semibold">
                      ID: {b._id.slice(-6).toUpperCase()}
                    </span>
                  </div>

                  {/* VENUE NAME */}
                  <div className="flex items-center gap-2 mt-2 mb-1">
                    <div>
                      <p className="font-medium text-gray-800 ">{b.venueId?.name}</p>
                    </div>
                  </div>

                  {/* DATE + TIME */}
                  <p className="text-sm text-[#444] mt-1">
                    {new Date(b.date).toLocaleDateString("en-GB", {
                      weekday: "short",
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}{" "}
                    • {b.startTime} - {b.endTime}
                  </p>

                  {/* COURT NAME */}
                  <p className="text-sm text-[#444] my-1">Court {b.courtName}</p>
                  <hr />
                  <div className="flex justify-between items-center ">
                    {/* USER */}
                    <p className="text-sm text-[#222] mt-2 capitalize">
                      {b.userId?.name}
                    </p>

                    {/* PRICE */}
                    <p className="text-sm font-bold text-[#0d2149]">₹ {b.price}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* FILTER DRAWER MODAL */}
        {showFilter && (
          <div
            className="fixed inset-0 flex justify-end bg-black bg-opacity-40 z-[9998]"
            style={{ pointerEvents: "auto" }}
          >
            <div
              className={`bg-white sm:mt-40 mt-0 w-full sm:w-[380px] h-full sm:h-auto sm:rounded-l-2xl shadow-xl flex flex-col transform transition-transform duration-300 ease-out filtersidebar ${
                window.innerWidth < 640 ? "translate-y-0" : "translate-x-0"
              } relative z-[10000]`}
            >
              {/* Header */}
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-semibold text-gray-800">Filter</h3>
                <button
                  onClick={() => setShowFilter(false)}
                  className="text-gray-500 hover:text-gray-800 text-xl"
                >
                  ✕
                </button>
              </div>

              {/* Body */}
              <div className="flex-1 overflow-y-auto p-5 space-y-4">
                {/* Start Date */}
                <div>
                  <p className="text-sm font-medium text-gray-700 mb-2">
                    Start Date
                  </p>
                  <DatePickerinCourtOwner
                    date={startDate}
                    onDateChange={setStartDate}
                    portalId="admin-filter-start"
                  />
                </div>

                {/* End Date */}
                <div>
                  <p className="text-sm font-medium text-gray-700 mb-2">
                    End Date
                  </p>
                  <DatePickerinCourtOwner
                    date={endDate}
                    onDateChange={setEndDate}
                    portalId="admin-filter-end"
                  />
                </div>
              </div>

              {/* Footer */}
              <div className="p-4 border-t flex justify-between gap-3">
                <button
                  onClick={() => {
                    const today = new Date();
                    setStartDate(today);
                    setEndDate(today);
                  }}
                  className="flex-1 border border-[#0d2149] text-[#0d2149] font-semibold py-1 text-sm rounded-full"
                >
                  RESET FILTER
                </button>

                <button
                  onClick={() => {
                    setShowFilter(false);
                    fetchSummary();
                    fetchList();
                  }}
                  className="flex-1 bg-[#0d2149] text-white font-semibold py-1 rounded-full"
                >
                  APPLY
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ✅ Sticky GET REPORT Button (Excel export) */}
<div className="fixed bottom-5 right-5 z-[10]">

          <div className="relative">
            <button
              onClick={() => setShowDropdown((prev) => !prev)}
              className="bg-[#0d2149] text-white font-semibold px-4 py-2 rounded-full shadow-lg flex items-center gap-2"
            >
              GET REPORT
              <span className="text-sm">▼</span>
            </button>

            {showDropdown && (
              <div className="absolute bottom-14 right-0 bg-white border rounded-lg shadow-lg overflow-hidden animate-fadeIn">
                <button
                  onClick={handleExportExcel}
                  className="block px-4 py-2 w-full text-left text-sm hover:bg-gray-100"
                >
                  📊 Export as Excel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function SummaryCard({ title, value, color }) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-3 border">
      <p className="text-xs text-gray-500">{title}</p>
      <p
        className={`text-lg font-bold ${
          color === "red" ? "text-red-600" : "text-[#0d2149]"
        }`}
      >
        {value}
      </p>
    </div>
  );
}
